import { render, staticRenderFns } from "./StoreHeader.vue?vue&type=template&id=320f98fd&"
import script from "./StoreHeader.vue?vue&type=script&lang=js&"
export * from "./StoreHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports